module.exports = __webpack_public_path__ + "static/media/svg-0.9d0649e0.svg";